import { render, staticRenderFns } from "./MonitorOrdenamiento.vue?vue&type=template&id=62281345&scoped=true"
import script from "./MonitorOrdenamiento.vue?vue&type=script&lang=js"
export * from "./MonitorOrdenamiento.vue?vue&type=script&lang=js"
import style0 from "./MonitorOrdenamiento.vue?vue&type=style&index=0&id=62281345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62281345",
  null
  
)

export default component.exports